import { render, staticRenderFns } from "./HelpSupportedElements.vue?vue&type=template&id=dafbbd74&scoped=true"
import script from "./HelpSupportedElements.vue?vue&type=script&lang=ts"
export * from "./HelpSupportedElements.vue?vue&type=script&lang=ts"
import style0 from "./HelpSupportedElements.vue?vue&type=style&index=0&id=dafbbd74&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafbbd74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dafbbd74')) {
      api.createRecord('dafbbd74', component.options)
    } else {
      api.reload('dafbbd74', component.options)
    }
    module.hot.accept("./HelpSupportedElements.vue?vue&type=template&id=dafbbd74&scoped=true", function () {
      api.rerender('dafbbd74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Help/HelpSupportedElements.vue"
export default component.exports